module.exports = "<div class=\"b3-map\">\n    <div class=\"map__wrap\">\n        <apm-map></apm-map>\n    </div>\n</div>\n"